import { render, staticRenderFns } from "./ClientServiceProporsal.vue?vue&type=template&id=5f0960ce&scoped=true"
import script from "./ClientServiceProporsal.vue?vue&type=script&lang=js"
export * from "./ClientServiceProporsal.vue?vue&type=script&lang=js"
import style0 from "./ClientServiceProporsal.vue?vue&type=style&index=0&id=5f0960ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0960ce",
  null
  
)

export default component.exports